import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import 'core-js';
import { store } from "./store";
import { vSafeHtml } from "./utils/sanitize";
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

import PrimeVue from 'primevue/config'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Badge from 'primevue/badge'
import Dropdown from 'primevue/dropdown'
import LitepieDatepicker from 'litepie-datepicker'
import VueClickAway from 'vue3-click-away'
import ToastService from 'primevue/toastservice'
import Calendar from 'primevue/calendar'
import Toast from 'primevue/toast'
import MultiSelect from 'primevue/multiselect'
import Paginator from 'primevue/paginator'
import ColumnGroup from 'primevue/columngroup'
import InlineMessage from 'primevue/inlinemessage';
import Row from 'primevue/row'
import InputMask from 'primevue/inputmask'
import Tooltip from 'primevue/tooltip';
import VuePlyr from 'vue-plyr'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueZoomer from 'vue-zoomer'
import VCalendar from 'v-calendar'
import vSelect from 'vue-select'
import InputNumber from 'primevue/inputnumber'
import MarqueeText from 'vue-marquee-text-component'
import AutoComplete from 'primevue/autocomplete';
import ListBox from 'primevue/listbox';
import Button from 'primevue/button'

import "./assets/css/tailwind.css"
import "./assets/css/all.min.css"
import "./permission.js"
import 'vue-plyr/dist/vue-plyr.css'
import 'vue-select/dist/vue-select.css'




const app = createApp(App)
    .use(store)
    .use(router)
    .use(PrimeVue)
    .use(LitepieDatepicker)
    .use(VueClickAway)
    .use(ToastService)
    .use(VuePlyr)
    .use(CKEditor)
    .use(VueZoomer)
    .use(VCalendar)


app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('InputText', InputText)
app.component('Dialog', Dialog)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('Badge', Badge)
app.component('Dropdown', Dropdown)
app.component('Toast', Toast)
app.component('Calendar', Calendar)
app.component('MultiSelect', MultiSelect)
app.component('Paginator', Paginator)
app.component('ColumnGroup', ColumnGroup)
app.component('Row', Row)
app.component('InputMask', InputMask)
app.component('InlineMessage', InlineMessage)
app.component('v-select', vSelect)
app.component('InputNumber', InputNumber)
app.component('marquee-text', MarqueeText)
app.component('AutoComplete', AutoComplete)
app.component('ListBox', ListBox)
app.component('Button', Button)
app.directive('tooltip', Tooltip)
app.directive('safe-html', vSafeHtml)
app.directive('focus', {
    mounted(el) {
        el.focus()
    }
})

app.mount('#app')